import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" No games at all will be generated. ");
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No leagues will be generated. ");
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" No cups will be generated. ");
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" No international teams will be generated. ");
import chance from "@/modules/base/services/chance";
import { app } from "@/di";
import { CountryEnum } from "@/modules/base/enums";
import CountryPicker from "@/modules/base/components/CountryPicker.vue";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  setup(__props) {
    const props = __props;
    const form = ref({
      team: {
        name: 'Borussia Dortmund',
        shortName: 'BvB',
        primaryColor: '#FDE100',
        secondaryColor: '#000000'
      },
      country: CountryEnum.DE,
      debug: {
        noGames: true,
        noLeague: false,
        noCup: false,
        noInternational: true
      }
    });
    const rules = ref({
      team: {
        name: {
          type: 'string',
          required: true,
          min: 3,
          max: 50,
          trigger: ['change']
        },
        shortName: {
          type: 'string',
          required: true,
          min: 3,
          max: 5,
          trigger: ['change']
        },
        primaryColor: {
          type: 'string',
          required: true,
          len: 7,
          trigger: ['change']
        },
        secondaryColor: {
          type: 'string',
          required: true,
          len: 7,
          trigger: ['change']
        }
      },
      country: {
        type: 'enum',
        required: true,
        enum: Object.values(CountryEnum),
        message: translator.t('select_a_country'),
        trigger: ['change'] // todo multiselect not working, need to use naive component
      },

      debug: {
        noGames: {
          type: 'boolean',
          required: true
        },
        noLeague: {
          type: 'boolean',
          required: true
        },
        noCup: {
          type: 'boolean',
          required: true
        },
        noInternational: {
          type: 'boolean',
          required: true
        }
      }
    });
    const countries = ref(app.get(ConfigRepository).get('general.playableCountries'));
    const router = useRouter();
    const formComponent = ref(null);
    const onSubmit = async () => {
      await formComponent.value.validate();
      router.push({
        name: 'game-slots.creating',
        query: {
          options: JSON.stringify(Object.assign({}, {
            gameSlotName: `game #${chance.integer()}`
          }, form.value))
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_NDivider = _resolveComponent("NDivider");
      const _component_NInput = _resolveComponent("NInput");
      const _component_NFormItem = _resolveComponent("NFormItem");
      const _component_NColorPicker = _resolveComponent("NColorPicker");
      const _component_NCheckbox = _resolveComponent("NCheckbox");
      const _component_NButton = _resolveComponent("NButton");
      const _component_NForm = _resolveComponent("NForm");
      return _openBlock(), _createBlock(_component_NForm, {
        ref_key: "formComponent",
        ref: formComponent,
        model: form.value,
        rules: rules.value,
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, {
        default: _withCtx(() => [_createVNode(DefaultInGameLayout, {
          "hide-header": "",
          "hide-footer": ""
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('create_new_game')), 1)]),
          footerButtons: _withCtx(() => [_createVNode(_component_NButton, {
            type: "success",
            strong: "",
            size: "large",
            "attr-type": "submit"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('create')), 1)]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_NDivider, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('team')), 1)]),
            _: 1
          }), _createVNode(_component_NFormItem, {
            label: _ctx.$t('name'),
            path: "team.name"
          }, {
            default: _withCtx(() => [_createVNode(_component_NInput, {
              value: form.value.team.name,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => form.value.team.name = $event),
              placeholder: _ctx.$t('name'),
              clearable: ""
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_NFormItem, {
            label: _ctx.$t('short_name'),
            path: "team.shortName"
          }, {
            default: _withCtx(() => [_createVNode(_component_NInput, {
              value: form.value.team.shortName,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => form.value.team.shortName = $event),
              placeholder: _ctx.$t('short_name'),
              clearable: ""
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_NFormItem, {
            label: _ctx.$t('primary_color'),
            path: "team.primaryColor",
            class: "flex-1 mr-2"
          }, {
            default: _withCtx(() => [_createVNode(_component_NColorPicker, {
              value: form.value.team.primaryColor,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => form.value.team.primaryColor = $event),
              "show-alpha": false,
              "show-preview": "",
              actions: ['confirm']
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_NFormItem, {
            label: _ctx.$t('secondary_color'),
            path: "team.secondaryColor",
            class: "flex-1"
          }, {
            default: _withCtx(() => [_createVNode(_component_NColorPicker, {
              value: form.value.team.secondaryColor,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => form.value.team.secondaryColor = $event),
              "show-alpha": false,
              "show-preview": "",
              actions: ['confirm']
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["label"])]), _createVNode(_component_NFormItem, {
            label: _ctx.$t('country'),
            path: "country"
          }, {
            default: _withCtx(() => [_createVNode(CountryPicker, {
              modelValue: form.value.country,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.country = $event),
              countries: countries.value
            }, null, 8, ["modelValue", "countries"])]),
            _: 1
          }, 8, ["label"]), _ctx.$debug ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_NDivider, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('debug')), 1)]),
            _: 1
          }), _createVNode(_component_NFormItem, {
            label: "No games",
            path: "noGames"
          }, {
            default: _withCtx(() => [_createVNode(_component_NCheckbox, {
              checked: form.value.debug.noGames,
              "onUpdate:checked": _cache[5] || (_cache[5] = $event => form.value.debug.noGames = $event)
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            }, 8, ["checked"])]),
            _: 1
          }), _createVNode(_component_NFormItem, {
            label: "No league",
            path: "noLeague"
          }, {
            default: _withCtx(() => [_createVNode(_component_NCheckbox, {
              checked: form.value.debug.noLeague,
              "onUpdate:checked": _cache[6] || (_cache[6] = $event => form.value.debug.noLeague = $event)
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 1
            }, 8, ["checked"])]),
            _: 1
          }), _createVNode(_component_NFormItem, {
            label: "No cup",
            path: "noCup"
          }, {
            default: _withCtx(() => [_createVNode(_component_NCheckbox, {
              checked: form.value.debug.noCup,
              "onUpdate:checked": _cache[7] || (_cache[7] = $event => form.value.debug.noCup = $event)
            }, {
              default: _withCtx(() => [_hoisted_4]),
              _: 1
            }, 8, ["checked"])]),
            _: 1
          }), _createVNode(_component_NFormItem, {
            label: "No international",
            path: "noInternational"
          }, {
            default: _withCtx(() => [_createVNode(_component_NCheckbox, {
              checked: form.value.debug.noInternational,
              "onUpdate:checked": _cache[8] || (_cache[8] = $event => form.value.debug.noInternational = $event)
            }, {
              default: _withCtx(() => [_hoisted_5]),
              _: 1
            }, 8, ["checked"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"]);
    };
  }
});